import { useContext, useRef } from "react";
import { LanguageContext } from "../Layout/LanguageContext";
import stylesModule from "./LanguageSwitcher.module.sass";
import { LANGUAGES } from "./constLanguage";

import useUnmountComponent from "../../hooks/useUnmountComponent";

const LanguageSwitcher = props => {
  const { unmount } = props;
  const { setLanguage } = useContext(LanguageContext);
  const path = window.location.pathname.split("/");
  const lang = path[1];
  const localRef = useRef(null);

  const changeLanguage = newLang => {
    setLanguage(newLang);
    const newPath = window.location.pathname.replace(`/${lang}`, `/${newLang}`);
    history.pushState(null, "", newPath);
    location.reload();
  };

  useUnmountComponent(localRef, unmount);

  return (
    <div className={stylesModule.changeLanguage} ref={localRef}>
      {LANGUAGES.map(language => (
        <button
          className={`${stylesModule.languageBtn} ${
            lang == language.key && stylesModule.languageSelected
          }`}
          onClick={() => changeLanguage(language.key)}
          key={language.key}
        >
          {language.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
